import React from 'react';
import {
  Generate3DOverlayRoot,
  Generate3DOverlayCard,
  Generate3DOverlayTitle,
  Generate3DOverlaySpinner,
  Generate3DOverlayStatus,
  Generate3DProgressTrack,
  Generate3DProgressFill,
  Generate3DProgressLabel,
  Generate3DErrorText,
  Generate3DActionRow,
  Generate3DActionButton,
} from '../imageCanvasStyles';

const STATUS_LABELS = {
  STARTED: 'Queuing your image for generation...',
  PENDING: 'Waiting in queue...',
  IN_PROGRESS: 'Building your 3D model...',
  SUCCEEDED: 'Opening your 3D model...',
  FAILED: 'Generation failed.',
  CANCELED: 'Generation was canceled.',
  UNKNOWN: 'Checking generation status...',
};

const Generate3DOverlay = ({
  theme,
  selectedTheme,
  status,
  progress,
  error,
  onClose,
}) => {
  const shared = { theme, $selectedTheme: selectedTheme };
  const isError = Boolean(error);
  const isDone = status === 'SUCCEEDED';
  const showSpinner = !isError && !isDone;
  const statusLabel = isError
    ? STATUS_LABELS.FAILED
    : STATUS_LABELS[status] || STATUS_LABELS.UNKNOWN;
  const safeProgress = Math.max(0, Math.min(100, Number(progress) || 0));

  return (
    <Generate3DOverlayRoot>
      <Generate3DOverlayCard {...shared}>
        <Generate3DOverlayTitle {...shared}>
          {showSpinner && <Generate3DOverlaySpinner {...shared} />}
          {isError ? 'Generation failed' : 'Generating 3D model...'}
        </Generate3DOverlayTitle>

        <Generate3DOverlayStatus {...shared}>
          {statusLabel}
        </Generate3DOverlayStatus>

        {!isError && (
          <>
            <Generate3DProgressTrack {...shared}>
              <Generate3DProgressFill {...shared} $progress={safeProgress} />
            </Generate3DProgressTrack>
            <Generate3DProgressLabel {...shared}>
              <span>Progress</span>
              <span>{safeProgress}%</span>
            </Generate3DProgressLabel>
          </>
        )}

        {isError && (
          <Generate3DErrorText {...shared}>{error}</Generate3DErrorText>
        )}

        {(isError || !showSpinner) && onClose && (
          <Generate3DActionRow>
            <Generate3DActionButton {...shared} $primary onClick={onClose}>
              Close
            </Generate3DActionButton>
          </Generate3DActionRow>
        )}
      </Generate3DOverlayCard>
    </Generate3DOverlayRoot>
  );
};

export { Generate3DOverlay };
